import { CLIENTS } from '@src/graphql/queries/client';
import { usePaginatedFetchItems } from 'pe-core-frontend';
export const useClients = ({ initialPageSize, id, parentId, excludeChildren, searchText, isActive, skip, } = {
    initialPageSize: 10,
}) => {
    const { page, setPage, pageSize, setPageSize, orderBy, setOrderBy, orderByDir, setOrderByDir, total, items: clients, loading, error, find, refetch, } = usePaginatedFetchItems({
        spec: {
            ...(id && { id }),
            ...(parentId && { parentId }),
            ...(excludeChildren && { excludeChildren }),
            ...(searchText && { name: searchText }),
            ...(isActive !== undefined && { isActive }),
        },
        fetchQuery: CLIENTS,
        dataProp: 'clients',
        initialPageSize,
        skip,
    });
    return {
        clients,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        orderBy,
        setOrderBy,
        orderByDir,
        setOrderByDir,
        error,
        total,
        find,
        refetch,
    };
};
